import { render, staticRenderFns } from "./montant.vue?vue&type=template&id=56501b4e"
import script from "./montant.vue?vue&type=script&lang=js"
export * from "./montant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports